module.exports = __webpack_public_path__ + "static/media/Appointment_dark.f445c4e2.png";